import { Icon } from '@iconify/react';
import React from 'react';
import { Link } from 'react-router-dom';

export default function Post({
  id,
  title,
  image,
  thumbUrl,
  created_at,
  socialShare,
  variant,
}) {

  // ✅ Save ID locally and open blog-details
  const handleOpenBlog = () => {
    localStorage.setItem("selectedBlogId", id);
  };

  return (
    <div className={`cs_post cs_style_1 ${variant}`}>
      <Link to={`/blog-details/${id}`} onClick={handleOpenBlog} className="cs_post_thumb cs_view_mouse">
        <img
          src={image || thumbUrl || "/images/blog/default.png"}
          alt={title}
          style={{
            width: "100%",
            height: "260px",
            objectFit: "contain",
            objectPosition: "center",
            backgroundColor: "#f4f6f8",
            borderRadius: "10px",
          }} // ✅ same card height, but the whole image always stays visible instead of being cropped
        />
      </Link>

      <div className="cs_post_info">
        <div>
          <div className="cs_post_meta">
            <div className="cs_posted_by">{created_at}</div>

            {socialShare && (
              <div className="cs_post_social">
                <Link to="/" className="cs_center rounded-circle">
                  <Icon icon="fa-brands:linkedin-in" />
                </Link>
                <Link to="/" className="cs_center rounded-circle">
                  <Icon icon="fa-brands:facebook-f" />
                </Link>
                <Link to="/" className="cs_center rounded-circle">
                  <Icon icon="fa-brands:twitter" />
                </Link>
              </div>
            )}
          </div>

          <h2 className="cs_post_title cs_semibold cs_fs_32">
            <Link to={`/blog-details/${id}`} onClick={handleOpenBlog}>{title}</Link>
          </h2>
        </div>

        <div className="cs_heading_color cs_medium">
          <Link to={`/blog-details/${id}`} onClick={handleOpenBlog} className="cs_post_btn">
            Learn More
          </Link>
        </div>
      </div>
    </div>
  );
}
